"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
function default_1({ room_id }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-blue-10", css: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            columnGap: '8px',
            height: '32px',
        } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1 gray-80" }, { children: t('결제마감 됐어요!') })), (0, jsx_runtime_1.jsx)("a", Object.assign({ className: "subtitle5 blue-50", href: `/room/room_view/?room_id=${room_id}` }, { children: t('다시 구매하기') }))] })));
}
exports.default = default_1;
